
import React, { useEffect, useState } from 'react'
import { SearchIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import Layout from "../../components/Layout/Layout";
import { Link } from "react-router-dom";
import ActionDropdown from "../../components/ActionDropdown";
import { Fragment } from 'react'
import AccountServices from '../../services/AccountServices';
import Paginate from '../../utils/Paginate';
import { convert, formatDate, pascalCASE, DisplayTime } from './../../utils/convertDate';
import DatePicker from 'react-date-picker';



function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const statusStyles = {
  Approved: 'bg-green-500 text-white',
  Open: 'bg-orange-600 text-white',
  Initiated: 'bg-amber-400 text-white',
  true:'bg-orange-600 text-white',
  false:'bg-green-500 text-white'
}
export default function AccountOpening() {
  const id = new URLSearchParams(window.location.search).get("code");
 

  const [accounts, setAccount] = useState([])
  const [search, setSearch] = useState("")
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0)
  const [nextPage, setNextPage] = useState(false)
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("")
  const [pageLength, setPageLength] = useState("");
  const oldFrom = new Date().setDate(new Date().getDate() - 7);
  const [formValues, setFormValues] = useState({
    from: new Date(oldFrom),
    to: new Date()
  })
  const defaultTo = formatDate(new Date());
  const longNew = formatDate(defaultTo);
  const [too, setToo] = useState(convert(longNew));
  const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
  const longDate = formatDate(defaultFrom);
  const [fromm, setFromm] = useState(convert(longDate));
  const [status, setStatus] = useState("");
  const [pnd, setPnd] = useState("");
  const [mandate, setMandate]= useState("");
  const [misCode, setMisCode] = useState("");


  const listAllAccount = async (search, from, to, makerCheckerStatus, pndLifted, mandateUploaded, misCode) => {
    const account = await AccountServices.listAccounts(pageIndex, 10, search?? "", from?? "", to?? "", makerCheckerStatus??"", pndLifted??"" ,mandateUploaded?? "",misCode?? "");
    setAccount([...account.data.result]);
    setPageLength([...account.data.result].length)
    setPageNumber(account.data.totalCount)
    setPageIndex(account.data.pageIndex)
    setPrev(account.data.hasPreviousPage);
    setPage(account.data.totalPages)
    setNextPage(account.data.hasNextPage)
  }

  const searchAccount = async (text) => {
    setSearch(text);
  };

  const range = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formValues.from)
    setFrom(formValues.from)
    var longDate = formatDate(newDate);
    setFromm(convert(longDate));

    const toDate = formatDate(formValues.to);
    setTo(formValues.to)
    setToo(convert(toDate));

    listAllAccount(search, convert(newDate), convert(toDate), status, pnd, mandate, misCode);

  }
  const handlePnd = async (text) => {
    text = text === "All" ? "" : text;
    setPnd(text);
    listAllAccount(search, fromm, too, status, text,mandate, misCode);

  }
  const handleMandate = async (text) => {
    text = text === "All" ? "" : text;
    setMandate(text);
    listAllAccount(search, fromm, too, status,pnd, text, misCode);
  }
  const handleSort = async (text) => {
    text = text === "All" ? "" : text;
    setStatus(text);
   listAllAccount(search, fromm, too, text, pnd, mandate, misCode);

  }
  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event })
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event })
    }
  };
  const handleExport = async () => {
    const resp = await AccountServices.exportAcct(search, fromm, too);
    window.open(resp.data);
  }
  useEffect(() => {
    setMisCode(id); 
    if(id === null){
      listAllAccount(search, fromm, too, status, pnd, mandate, misCode);
    }
    listAllAccount(search, fromm, too, status, pnd, mandate, id);
   
  }, [pageIndex]);
  return (<>
    <Layout title="Account Opening" pageTag={'account'} current={'/accounts'}>
      <React.Fragment>
        <main>
          <div className='max-w-7xl mx-auto '>
            <div className=''>
              <div className="">
                <div className="mt-5 sm:ml-16 flex justify-end">
                  <button
                    type="button"
                    onClick={handleExport}
                    className="mr-2 inline-flex active:text-white items-center justify-center rounded-md border border-transparent hover:text-white btn-green px-3 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                  >
                    <DocumentDownloadIcon className="w-4 mr-1.5" />
                    Export CSV
                  </button>
                </div>
                <div className="sm:flex sm:items-center">
                  <div className="sm:flex-auto flex">
                    <div className=" relative rounded-md shadow-sm ml-3">
                      <p className='text-sm leading-3 text-gray-500'>From</p>
                      <div>
                        <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                      </div>
                    </div>
                    <div className=" relative rounded-md shadow-sm ml-3">
                      <p className='text-sm leading-3 text-gray-500'>To</p>
                      <div>
                        <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                      </div>
                    </div>
                    <div className="mt-5 ml-4 relative rounded-md shadow-sm">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                      </div>
                      <input
                        type="text"
                        name="user"
                        id="user"
                        onChange={(e) => searchAccount(e.target.value)}
                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                        placeholder="Search account"
                      />
                    </div>
                    <div className="mt-5 ml-4 relative rounded-md shadow-sm">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                      </div>
                   
                    </div>
                    <div className='mt-5 ml-3'>
                      <button
                        onClick={range}
                        className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                    </div>
                  </div>
                </div>
                <div className='sm:flex-auto flex'>               
               
                    <div className="mt-5 relative rounded-md shadow-sm ml-3">
                      <select
                        id="activationApprovalStatus"
                        name="activationApprovalStatus"
                        onChange={(e) => handleSort(e.target.value)}
                        placeholder="Filter by"
                        className="focus:ring-indigo-500 focus:border-indigo-500 h-full  pl-2  border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                      >
                        <option value={"All"}>Filter by approval status</option>
                        <option value={"Open"}>Open</option>
                        <option value={"Initiated"}>Initiated</option>
                        <option value={"Approved"}>Approved</option>
                      </select>
                    </div>
                    <div className="mt-5 relative rounded-md shadow-sm ml-3">
                      <select
                        id="currency"
                        name="currency"
                        onChange={(e) => handlePnd(e.target.value)}
                        placeholder="Filter by"
                        className="focus:ring-indigo-500 focus:border-indigo-500 h-full  pl-2  border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                      >
                        <option value={"All"}>Sort by restriction</option>
                        <option value={true}>PND Lifted</option>
                        <option value={false}>PND Not Lifted</option>
                      </select>
                    </div>
                    <div className="mt-5 relative rounded-md shadow-sm ml-3">
                      <select
                        id="currency"
                        name="currency"
                        onChange={(e) => handleMandate(e.target.value)}
                        placeholder="Filter by"
                        className="focus:ring-indigo-500 focus:border-indigo-500 h-full  pl-2  border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                      >
                        <option value={"All"}>Sort by mandate</option>
                        <option value={true}>Mandate Uploaded</option>
                        <option value={false}>Mandate not uploaded</option>
                      </select>
                    </div>
                </div>
                {accounts.length === 0 ?
                  (
                    <div className=" mt-8"> No data available for these dates to show. </div>
                  ) :
                  <>
                    <div className="mt-8 flex ">
                      <div className="-my-2  overflow-x-auto ">
                        <div className="inline-block min-w-full py-2 align-middle">
                          <div className="relative   ring-black ring-opacity-5 md:rounded-lg">
                            <table className="min-w-full table-fixed divide-y divide-gray-300">
                              <thead>
                                <tr>
                                  <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-500">
                                    Account Number
                                  </th>
                                  <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-500">
                                    Account Name
                                  </th>
                                  <th scope="col" className="min-w-[8rem]  py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Account Currency
                                  </th>
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Account Type
                                  </th>
                                  <th scope="col" className="min-w-[12rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    PND Approval Status
                                  </th>
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    PND Lifted
                                  </th>
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Mandate Uploaded
                                  </th>
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Mandate Approval Status
                                  </th>
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Bank Verfication Number
                                  </th>
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Branch Name
                                  </th>
                                  <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Email Address
                                  </th>
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                     Date Account Opened
                                                                   </th>
                                                                   <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                     Time Created
                                                                   </th>
                                                                   <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                     Phone Number
                                  </th>
                                  <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                    <span className="sr-only">Edit</span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white">
                                {accounts.map((person, i) => (
                                  <tr key={i} className="bg-gray-50">
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accountNumber} </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{pascalCASE(person.firstName)} {person.lastName} </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accountCcy}</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accountClass}</td>
                                    <td>
                                      <span className={classNames(
                                        statusStyles[person.activationApprovalStatus], "inline-flex items-center px-2.5 py-1.5 rounded-full text-sm font-medium text-gray-900")}>{person.activationApprovalStatus}</span>
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.pndLifted === true ? "PND Lifted" : "PND Not Lifted"}</td>
                                    <td className= "whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.mandateUploaded === true ? "Yes" : "No"}</td>
                                    <td>
                                      <span className={classNames(
                                        statusStyles[person.mandateApprovalStatus], "inline-flex items-center px-2.5 py-1.5 rounded-full text-sm font-medium text-gray-900")}>{person.mandateApprovalStatus}</span>
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.bvnNumber}</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.branchName}</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.email}</td>
<td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatDate(person.dateCreated)}</td>
                                                                     <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{DisplayTime(person.dateCreated)}</td>
                                                                     <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.phoneNumber}</td>
                                    <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6" value={person.id}>
                                      <ActionDropdown
                                        items={[
                                          { label: "View Account", onClick: () => window.location.href = `/view/account?id=${person.accountNumber}` },
                                          { label: "Review Document", onClick: () => window.location.href = `/customer/document?id=${person.username}` },
                                        ]}
                                        dropdownWidth="w-40"
                                      />

                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Paginate
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        totalCount={pageNumber}
                        totalPages={totalPage}
                        prevPage={prevPage}
                        setPageIndex={setPageIndex}
                    />
                  </>}

              </div>

            </div>
          </div>
        </main>

      </React.Fragment>
    </Layout>



  </>);
}